import type { FaireProductEntity } from "../../entity_types/product";

export const p_haezay2279: FaireProductEntity = {
  token: "p_haezay2279",
  type: "product",
  name: "Tahitian Huggy Hoops - 18mm",
  brandName: "Keshi Co",
  imageUrl:
    "https://cdn.faire.com/fastly/cb452f3ef29fb4d67aed81816de820a71dea809a70bf4ef269fe06a8e4172e35.jpeg",
  priceDollars: 75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/65de55d61f2157e94627836176b1b34c246c1571b4c9ba2895598bf9b7500744.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
